"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgrounds = exports.backgroundOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _plugins = _interopRequireDefault(require("../../plugins.js"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _upload = _interopRequireDefault(require("cccisd-icons/svg/upload"));
var _backgrounds = _interopRequireDefault(require("./backgrounds.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var backgroundContext = process.env.NODE_ENV === 'test' ? {
  keys: function keys() {
    return [];
  }
} : require.context('./backgrounds', true, /\S*index.js/);
var backgrounds = exports.backgrounds = {};
var backgroundOptions = exports.backgroundOptions = [{
  label: 'No background',
  value: ''
}, {
  label: 'Solid Color',
  value: 'solidColor'
}, {
  label: 'Custom Image',
  value: 'uploadedImage',
  renderPickerItem: function renderPickerItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _backgrounds["default"].thumbnail
    }, /*#__PURE__*/_react["default"].createElement(_upload["default"], null));
  }
}].concat(_toConsumableArray(backgroundContext.keys().map(function (key) {
  var value = key.replace(/^(\.\/)([^/]*)(.*)$/, '$2');
  var info = backgroundContext(key)["default"];
  backgrounds[value] = info;
  return {
    label: info.name || (0, _capitalize2["default"])(value),
    value: value,
    thumbnail: info.thumbnail
  };
})), _toConsumableArray((0, _get2["default"])(_plugins["default"], 'defaultTemplate.backgrounds', []).map(function (obj) {
  var value = "app_".concat(obj.code);
  backgrounds[value] = obj;
  return {
    value: value,
    label: obj.name,
    thumbnail: obj.thumbnail
  };
})));